import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Sparkles, Flame } from "lucide-react";

const TABS = [
  { to: "/dashboard",   label: "Dashboard",   icon: LayoutDashboard, testid: "tabbar-dashboard" },
  { to: "/simulate",    label: "Simulator",   icon: Sparkles,        testid: "tabbar-simulator" },
  { to: "/daily-picks", label: "Daily Picks", icon: Flame,           testid: "tabbar-daily-picks" },
];

/** Mobile-only bottom tab bar — sticks to the viewport bottom, three primary destinations. */
export const MobileTabBar = () => (
  <nav
    className="lg:hidden fixed bottom-0 inset-x-0 z-30 border-t border-border bg-gray-0/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
    aria-label="Primary"
    data-testid="mobile-tab-bar"
  >
    <ul className="flex items-stretch justify-around">
      {TABS.map(({ to, label, icon: Icon, testid }) => (
        <li key={to} className="flex-1">
          <NavLink
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-2 py-2 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                isActive ? "text-primary" : "text-gray-500 hover:text-gray-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`flex size-9 items-center justify-center rounded-lg transition-all ${isActive ? "bg-primary/10" : ""}`}>
                  <Icon className="size-[18px]" />
                </span>
                <span>{label}</span>
              </>
            )}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
